var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M147.57,68.57a9,9,0,1,0,9,9A9.011,9.011,0,0,0,147.57,68.57Zm4.476,7.079-5.181,4.914a.785.785,0,0,1-.511.195.662.662,0,0,1-.511-.219l-2.724-2.8a.723.723,0,0,1,1.046-1l2.214,2.286,4.67-4.427a.723.723,0,1,1,1,1.046Z",
    transform: "translate(-138.57 -68.57)",
    fill: "#41a6e9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.8d81ae0cae26da156be05ff83a1fbc79.svg";
export { ForwardRef as ReactComponent };